import { createApp } from 'vue'
import mitt from 'mitt'
import CalendarView from '@vueapp/views/Calendar.vue'



export class Calendar {
    constructor( elements ) {
        if ( elements ) {
            elements.forEach(function (item, key) {
                const emitter = mitt()
                const app = createApp(CalendarView, {
                    postId: item.getAttribute('data-post-id'),
                    postSlug: item.getAttribute('data-post-slug'),
                    isViewWrapper: item.getAttribute('data-is-viewwrapper')
                })
                app.config.globalProperties.emitter = emitter
                app.mount('#' + item.getAttribute('id') )
            });
        }
    }
}